import { useState } from "react";
import { toast } from "sonner";
import { FileText, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { downloadReport } from "../lib/api";

export const PdfButton = ({ params, label = "Cetak PDF", testId = "pdf-report-button", size, variant = "outline", className = "" }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await downloadReport(params);
    } catch {
      toast.error("Gagal membuat laporan PDF");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button variant={variant} size={size} onClick={run} disabled={busy} data-testid={testId} className={`active:scale-[0.98] transition-transform ${className}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileText className="h-4 w-4" />} {label}
    </Button>
  );
};
